
export class DishonestyHelper {

    private dateOfIncident: Date;
    private countryIncidentOccur: string;
    private countryIncidentOccurDesc: string;
    private descOfIncident: string;
    private amountClaim: string;
    private amountClaimCurrency: string;
    private isIncidentReport: boolean;
    private dateOfReport: Date;
    private policeStationNameAndAddress: string;
    private referenceNumber: string;
    private estimatedAmount: number;

    getEstimatedAmount(): number {
        return this.estimatedAmount;
    }

    setEstimatedAmount(value: number) {
        this.estimatedAmount = value;
    }

    getDateOfIncident(): Date {
        return this.dateOfIncident;
    }

    setDateOfIncident(value: Date) {
        this.dateOfIncident = value;
    }

    getCountryIncidentOccur(): string {
        return this.countryIncidentOccur;
    }

    setCountryIncidentOccur(value: string) {
        this.countryIncidentOccur = value;
    }

    getCountryIncidentOccurDesc(): string {
        return this.countryIncidentOccurDesc;
    }

    setCountryIncidentOccurDesc(value: string) {
        this.countryIncidentOccurDesc = value;
    }

    getDescOfIncident(): string {
        return this.descOfIncident;
    }

    setDescOfIncident(value: string) {
        this.descOfIncident = value;
    }

    getAmountClaim(): string {
        return this.amountClaim;
    }

    setAmountClaim(value: string) {
        this.amountClaim = value;
    }

    getAmountClaimCurrency(): string {
        return this.amountClaimCurrency;
    }

    setAmountClaimCurrency(value: string) {
        this.amountClaimCurrency = value;
    }

    getIsIncidentReport(): boolean {
        return this.isIncidentReport;
    }

    setIsIncidentReport(value: boolean) {
        this.isIncidentReport = value;
    }
    
    getDateOfReport(): Date {
        return this.dateOfReport;
    }

    setDateOfReport(value: Date) {
        this.dateOfReport = value;
    }

    getPoliceStationNameAndAddress(): string {
        return this.policeStationNameAndAddress;
    }

    setPoliceStationNameAndAddress(value: string) {
        this.policeStationNameAndAddress = value;
    }

    getReferenceNumber(): string {
        return this.referenceNumber;
    }

    setReferenceNumber(value: string) {
        this.referenceNumber = value;
    }  
    
    static jsonConvert(dishonestyHelper: DishonestyHelper): DishonestyHelper {

        //todo: convert date fields object if any
        if (dishonestyHelper.getDateOfIncident() != null) {
            dishonestyHelper.setDateOfIncident(new Date(dishonestyHelper.getDateOfIncident()));
        }

        if (dishonestyHelper.getDateOfReport() != null) {
            dishonestyHelper.setDateOfReport(new Date(dishonestyHelper.getDateOfReport()));
        }

        return dishonestyHelper;
    }
}